import { useScoringConfigRoutes } from "./routes";
import { GetDefaultIndex } from "../../components";
import { useGetScoringConfigCommonInfoQuery } from "../../features/identity/scoringApi";

export { useScoringConfigRoutes };

export default GetDefaultIndex({ title: "تنظیمات امتیازدهی", query: useGetScoringConfigCommonInfoQuery });
